/** Constants */

const Const = Object.freeze({
	PERMISSION_ROLE_BASE: 'ROLE_BASE',
	PERMISSION_ROLE_EXPORT_IMPORT_CONFIGURATION: 'ROLE_EXPORT_IMPORT_CONFIGURATION',
	PERMISSION_ROLE_EXPORT: 'ROLE_EXPORT',
	PERMISSION_ROLE_EDIT_ITEM: 'ROLE_EDIT_ITEM',
	PERMISSION_ROLE_MANAGER: 'ROLE_MANAGER',
	PERMISSION_ROLE_ADMIN: 'ROLE_ADMIN',
	PERMISSION_ROLE_IMPORT: 'ROLE_IMPORT',
	PERMISSION_ROLE_ATTACH_COMPANY: 'ROLE_ATTACH_COMPANY',
	PERMISSION_ROLE_DELETE_ITEM: 'ROLE_DELETE_ITEM'
})

export default Const
